<template>
  <div>
    <div v-if="canView" class="pa-4">
      <div class="px-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="groupInfo.title"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Nhóm lương', href: '../../salary-group' },
              { text: groupInfo.title }
            ]"
          />
        </div>
      </div>
      <v-card outlined class="px-4 py-6 mx-4 my-6 elevation-0">
        <DetailInfoGroup />
      </v-card>
      <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
        <v-tab v-for="item in tabList" :key="item" class="tab-default">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-card outlined class="mx-md-4 elevation-0">
        <v-tabs-items v-model="tab">
          <v-tab-item :key="1">
            <ListActions />
            <v-card sm="12" class="mx-4">
              <TeacherTable />
            </v-card>
            <v-col sm="12" class="d-flex justify-center">
              <v-btn v-if="canDelete" outlined color="error" class="mx-1 mt-2" @click="deleteThisGroup">
                Xoá nhóm đối tượng
              </v-btn>
            </v-col>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-card sm="12" class="mx-4 my-4">
              <GroupHeadTable category="main" />
            </v-card>
          </v-tab-item>
          <v-tab-item :key="3">
            <v-card sm="12" class="mx-4 my-4">
              <GroupHeadTable category="adjust" />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import DetailInfoGroup from './group-detail/Info.vue'
import ListActions from './group-detail/ListActions.vue'
import TeacherTable from './group-detail/TeacherTable.vue'
import GroupHeadTable from './group-detail/GroupHeadTable.vue'
import Page403 from '@/views/Page403.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      tab: null,
      tabList: ['Danh sách giáo viên', 'Thành phần lương đã gán', 'Điều chỉnh lương đã gán']
    }
  },
  async created() {
    await this.resetData()
    await this.fetchOne(this.$route.params.id)
    await this.getTotalStudent(this.groupInfo)
  },
  components: {
    TeacherTable,
    GroupHeadTable,
    Breadcrumbs,
    DetailInfoGroup,
    ListActions,
    Page403
  },
  computed: {
    ...mapGetters('salaryGroup', ['groupInfo', 'typeGroup']),
    canView() {
      return true
    },
    canDelete() {
      return true
    }
  },
  methods: {
    ...mapActions('salaryGroup', ['fetchOne', 'deleteGroup']),
    ...mapActions('salaryGroupTeacher', [
      'searchStudentsSalary',
      'searchStudentsDefault',
      'requestPageSettings',
      'resetData'
    ]),
    ...mapActions('salaryGroupTeacher', ['getTotalStudent', 'requestPageSettings']),
    async deleteThisGroup() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa nhóm đối tượng?',
        text: '<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá nhóm đối tượng?</div>',
        okText: 'Xóa',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            await this.deleteGroup(this.$route.params.id)
            this.$alert.deleteSuccess('nhóm đối tượng')
            this.$router.push({ path: '../../salary-group' })
          } catch (e) {
            this.$alert.deleteError({
              title: 'Lỗi thao tác',
              description: 'Không thể xóa nhóm đối tượng. Vui lòng thử lại!'
            })
          }
        }
      })
    }
  }
}
</script>
